<template>
  <!-- The runner card's own switch, only for whoever the card is for -->
  <v-list-item
    v-if="hasRunnerCard"
    :prepend-icon="mdiRobotOutline"
    data-testid="user-menu-runner-card"
    @click="uiSettingsStore.showRunnerCard = !uiSettingsStore.showRunnerCard"
  >
    <template #append>
      <WSwitch
        :model-value="uiSettingsStore.showRunnerCard"
        aria-label="Show my runner in the sidebar"
        hide-details
        @click.stop
        @update:model-value="uiSettingsStore.showRunnerCard = $event"
      />
    </template>
    <v-list-item-title>My runner in the sidebar</v-list-item-title>
  </v-list-item>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { mdiRobotOutline } from '@mdi/js'
import WSwitch from '@wasabi/inputs/WSwitch.vue'

import { useAuthStore } from '@/stores/auth.store'
import { useUiSettingsStore } from '@/stores/ui-settings.store'
import { useClaudeFleetRunnersStore } from '@/stores/claude-fleet-runners.store'
import { runnerCardEligible } from '@/services/claude-fleet'

const authStore = useAuthStore()
const uiSettingsStore = useUiSettingsStore()
const runnersStore = useClaudeFleetRunnersStore()

const hasRunnerCard = computed(
  () => runnersStore.loaded && runnerCardEligible(runnersStore.runners, authStore.user?.email, runnersStore.viewerEngineer)
)
</script>
